var exports = {
  "AS": "x31de4314--c84381--item",
  "Sl": "x31de4314--c84381--image",
  "nf": "x31de4314--c84381--link",
};

module.exports = exports;
